import dayjs from 'utils/customDayJS';

export const formatAdvisoryDetailKeyAndValue = item => {
	const typesToInclude = ['string', 'timestamp', 'link', 'linkToLAANC', 'linkToCustom'];
	let value;
	let key = item.key;
	if (!typesToInclude.includes(item.type)) return { key: '', value: '' };

	if (item.type === 'string') {
		value = item.value;
	}

	if (item.type === 'link') {
		const maxChar = 32;
		let contentText = item.value;
		contentText =
			contentText.length >= maxChar ? `${contentText.slice(0, maxChar)}...` : contentText;
		value = (
			<a target='_blank' href={item.value} rel='noopener noreferrer'>
				{contentText}
			</a>
		);
	}

	if (item.type === 'timestamp') {
		const localTimezone = dayjs().tz(dayjs.tz.guess()).format('z');
		value = `${dayjs(item.value * 1000).format('MM/DD/YY [at] h:mma')} ${localTimezone}`;
	}
	return { key, value };
};

export const determineIfLAANCEnabled = advisory => {
	const airport1Enabled = advisory.properties.APT1_ENABLED;
	if (airport1Enabled) {
		return airport1Enabled.includes('107-FC') || airport1Enabled.includes('107-AA');
	} else {
		return false;
	}
};
